import { apiConstants } from '../../apiConstant'
import { formDataCommonFunction, serviceCall } from '../../serviceCall'

export const createPaymentMethodByCustomerId = (data, callback, errorCallBack) => {

    return async (dispatch) => {

        formDataCommonFunction(data, apiConstants.PAYMENT_GATEWAY.CREATE_PAYMENT_METHOD_BY_CUSTOMER_ID)
            .then((response) => {
                callback && callback(response)

            })
            .catch((error) => {
                errorCallBack && errorCallBack(error.response)
            })
    }
}